export default __webpack_public_path__ + "static/media/visuals-icons.0168a6e5.svg";